import React, { Component } from "react";
import close from "../../../../include/images/icon-close.svg";
import avatar from "../../../../include/images/avatar-1.png";
import document from "../../../../include/images/documnent-placholder.svg";
import attachment from "../../../../include/images/attachment.svg";
import icon from "../../../../include/images/send-icon.svg";
import {
  chatReceived,
  chatReceivedAll,
  getChats,
  loadChatForPatient,
} from "../../../../store/chats";
import { io } from "socket.io-client";
import { getPatient, loadPatientProfile } from "../../../../store/patient";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import moment from "moment";
import { collection, doc, getDoc, getDocs, query, updateDoc, where, orderBy } from "firebase/firestore";
import { sendMessage } from "../../../../chatUtils/chatUtiles";
import { db } from "../../../../firebase";

class Messages extends Component {
  myRef = React.createRef();
  scrollToMyRef = () => {
    if (this.myRef.current) {
      const scroll =
        this.myRef.current.scrollHeight - this.myRef.current.clientHeight;
      this.myRef.current.scrollTo(0, scroll);
    }
  };
  state = {
    ready: false,
    msgData: "",
    initialBottomScrollDone: false,
  };
  loadMessages = async () => {
    if (!this.props.doctor_id || !this.props.patient_id) return;
    const q = query(
      collection(db, "messages"),
      where("sender", "in", [this.props.patient_id, this.props.doctor_id]),
      where("receiver", "in", [this.props.patient_id, this.props.doctor_id]),
      orderBy("created_on", "asc")
    );
    const snapshot = await getDocs(q);
    const msgs = snapshot.docs.map((doc) => {
      const data = doc.data();
      // console.log("msg data------------------> ",data)
      return {
        ...data,
        created_on: data.created_on?.toDate?.().toISOString() || data.created_on,
        time: data.time?.toDate?.().toISOString() || data.time,
      };
    });
    // console.log("messages ------------999----------> ", msgs)
    this.props.chatReceivedAll(msgs);

    const chatId = `${this.props.doctor_id}_${this.props.patient_id}`;
    const chatDocRef = doc(db, "chatsSummary", chatId);
    const chatDocSnap = await getDoc(chatDocRef);
    if(chatDocSnap.exists() && this.props.tab === ('messages' || 'message')){
      const data = chatDocSnap.data();
      if (data.readByPatient === false) {
        console.log("I am doing *************")
        await updateDoc(doc(db, "chatsSummary", chatId), {
          readByPatient: true,
        }, { merge: true });
      }
    }  
    // this.scrollToMyRef(false);
  }; 
  handleSend = async (msg) => {
    if (msg) {
      await sendMessage({
        msg: this.state.msgData,
        doctorId: this.props.doctor_id,
        patientId: this.props.patient_id,
        sender: this.props.patient_id,
      })
      this.setState({ msgData: '' }, () => {
       this.scrollToMyRef();
      });
      this.loadMessages();
    }
  }

  // recievedMsg = (msg) => {
  //   this.props.chatReceived(msg);
  //   this.scrollToMyRef();
  // };

  componentWillUnmount = () => {
    clearInterval(this.pollInterval);
  };

  componentDidUpdate = (prevProps, prevState) => {
    // console.log("-----333---------")
    if (
      this.props.chats.length !== prevProps.chats.length &&
      this.props.chats.length > 0
    ) {
    this.scrollToMyRef();
  }
    if (this.props.doctor_id != prevProps.doctor_id) {
      this.props.loadChatForPatient(this.props.doctor_id);
    }
  };

  componentDidMount = () => {
    // console.log("------componentDidMount------")
    this.scrollToMyRef();
    if (this.props.doctor_id) {
      this.props.loadChatForPatient(this.props.doctor_id);
    }
    this.loadMessages();
    this.pollInterval = setInterval(() => {
      // console.log("loading----->")
      this.loadMessages();
    }, 5000);
  };
  render() {
    const days = moment().diff(
      moment(this.props.lastAppointment.appointment_time),
      "days"
    );

    return (
      <>
        <div
          className={
            this.props.isShow === true
              ? "sidebar-box notesopen"
              : "sidebar-box notesclose"
          }
          id="calculator"
        >
          <div class="sidebar-head d-flex align-items-center">
            <h5>
              Chats{" "}
              <small>
                (Active for 3 days post appointment. Not for Emergency
                purposes.)
              </small>
            </h5>
            <div
              class="close-img ml-auto"
              onClick={(e) => {
                e.preventDefault();
                this.props.toggle(this.props.patient_id, this.props.doctor_id);
              }}
            >
              <img src={close} alt="" />
            </div>
          </div>
          <div class="sidebar-body height-auto">
            <div class="chats-box">
              <div class="chats-head d-flex align-items-center">
                <div class="d-flex align-items-center">
                  <div class="doc-thumbnails">
                    <img
                      style={{ borderRadius: "50%" }}
                      src={process.env.REACT_APP_S3URL + this.props.image}
                      alt=""
                    />
                  </div>
                  <div class="doc-text-box">
                    <h4>{this.props.doc_name}</h4>
                    <p>
                      {this.props.field}, Addiction {this.props.field}
                    </p>
                  </div>
                </div>
              </div>
              <div class="chat-area">
                <div class="chat" ref={this.myRef}>
                {this.props.chats.map((es, i) => {
                 const createdOn = es.created_on?.toDate?.() || es.created_on;
                 const time = es.time?.toDate?.() || es.time; 
                 return ( 
                    <>
                      {(i === 0 ||
                        moment(
                          this.props.chats[i - 1]?.created_on?.toDate?.() ||
                          this.props.chats[i - 1]?.created_on
                        ).format("DD/MM/YYYY") !==
                          moment(createdOn).format("DD/MM/YYYY")) && (
                        <div class="chat-seprator"
                          id={moment(createdOn).format("DD/MM/YYYY")}>
                          <span>
                            {" "}
                            {moment(createdOn).format("DD/MM/YYYY")}
                          </span>
                          <div className="alert_box">
                            <div className="alert_box_content">
                            This chat is not for emergency purposes. Messages exchanged here is between you and your respective field expert only. YesMindy has no role in checking the messages or responses by the expert. Reply from the expert may take sometime.  
                            </div>
                          </div> 
                        </div>
                      )}
                      {this.props.patient_id === es.sender ? (
                        <div class="chat-message-box send-message">
                          <div>
                            <div class="chat-message">
                              {es.msg || es.message}
                            </div>
                          </div>
                          <div class="time">
                            {moment(createdOn).format("hh:mm:ss A")}{" "}
                          </div>
                        </div>
                      ) : (
                        <div class="chat-message-box received-message d-flex flex-column align-items-end">
                          <div class="d-flex flex-column">
                            <div class="chat-message">
                              {es.msg || es.message}
                            </div>
                          </div>
                          <div class="time">
                            {" "}
                            {moment(time || createdOn).format("hh:mm:ss A")}{" "}
                          </div>
                        </div>
                      )}
                    </>
                 )
                 })}
                </div>
                {this.props.lastAppointment.appointment_time && days < 3 && (
                  <div class="send">
                    <input
                      onChange={(e) =>
                        this.setState({ msgData: e.target.value })
                      }
                      className="input-message"
                      name="msgData"
                      value={this.state.msgData}
                      placeholder="Write your message…"
                      type="text"
                      id="message"
                      onKeyDown={(e) => {
                        if (e.key === "Enter")
                          this.handleSend(this.state.msgData);
                      }}
                    />{" "}
                    <button
                      className="input-send"
                      onClick={(e) => {
                        if (this.state.msgData)
                          this.handleSend(this.state.msgData);
                      }}
                    >
                      <i>
                        <img src={icon} alt="" />
                      </i>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className={this.props.isShow === true ? "overlay4 show" : "overlay4"}
        ></div>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  patientProfile: getPatient(state).profile,
  patientHistory: getPatient(state).history,
  psychiatrist: getPatient(state).psychiatrist,
  psychologist: getPatient(state).psychologist,
  loading: getPatient(state).loading,
  chats: getChats(state).chatData,
  lastAppointment: getChats(state).lastAppointment,
});
const mapDispatchToProps = (dispatch) => ({
  loadPatientProfile: () => dispatch(loadPatientProfile()),
  chatReceived: (data) => dispatch(chatReceived(data)),
  chatReceivedAll: (data) => dispatch(chatReceivedAll(data)),
  loadChatForPatient: (id) => dispatch(loadChatForPatient(id)),
});
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Messages)
);
